// extracted by mini-css-extract-plugin
export default {"pdfContainer":"PDFViewer_pdfContainer__isupL","pdfWrapper":"PDFViewer_pdfWrapper__tZBV-","button":"PDFViewer_button__BuDXN"};